// extracted by mini-css-extract-plugin
export default {"avatar":"style_avatar__7BoyL","avatarGood":"style_avatarGood__h4q3a","avatarBad":"style_avatarBad__-9qod","avatarSimple":"style_avatarSimple__CjICx"};